import React from 'react';
import clsx from 'clsx'; // Optional: install clsx for cleaner class merging

const Button = ({
  children,
  variant = 'default',
  size = 'md',
  disabled = false,
  onClick,
  type = 'button',
  className = '',
  ...rest
}) => {
  const baseStyles = 'font-medium rounded focus:outline-none transition';

  const variants = {
    default: 'bg-[#4B006D] text-white',
    outline: 'border border-[#4B006D] text-[#4B006D] hover:text-[#fff] hover:bg-[#4B006D]',
    ghost: 'text-[#4B006D]',
    cancel: 'bg-white border border-gray-300 text-gray-700 hover:bg-gray-50',
  };

  const sizes = {
    xs: 'px-2 py-1 text-xs',
    sm: 'px-1 py-1 text-sm',
    md: 'px-4 py-2 text-base',
    lg: 'px-5 py-3 text-lg',
  };

  const disabledStyles = disabled ? 'opacity-50 cursor-not-allowed' : '';

  return (
    <button
      type={type}
      disabled={disabled}
      onClick={onClick}
      className={clsx(
        baseStyles,
        variants[variant],
        sizes[size],
        disabledStyles,
        className
      )}
      {...rest}
    >
      {children}
    </button>
  );
};

export default Button;
